export const formRange = () => {
    const formRanges = document.querySelectorAll(".form-range");
    if (!formRanges.length) return;

    const handleFormRange = (element) => {
        const baseMin = Number(element.getAttribute("data-min")) || 0;
        const baseMax = Number(element.getAttribute("data-max")) || 0;
        const form = element.closest(".archive-filters") || document.querySelector(".archive-filters");
        const minGap = Math.max(1, Math.round(((baseMax - baseMin) / 100) * 3));
        if (!form) return;

        const track = element.querySelector(".form-range__track");
        const rangeInputs = element.querySelectorAll(".form-range__input-range");
        const minInput = form.querySelector("[name='price_from']");
        const maxInput = form.querySelector("[name='price_to']");
        const placeholderFrom = form.querySelector("[data-placeholder-from]");
        const placeholderTo = form.querySelector("[data-placeholder-to]");
        const filterItemPlaceholder = form.querySelector(".archive-filters__filter-name.-price");
        const minRange = rangeInputs[0];
        const maxRange = rangeInputs[1];
        if (!track || !minInput || !maxInput || !minRange || !maxRange || !filterItemPlaceholder) return;

        const syncTrackAndPlaceholders = () => {
            const currentMin = Number(minInput.value) || baseMin;
            const currentMax = Number(maxInput.value) || baseMax;

            minRange.value = currentMin;
            maxRange.value = currentMax;
            if (placeholderFrom) placeholderFrom.textContent = currentMin;
            if (placeholderTo) placeholderTo.textContent = currentMax;
            handleTrackColor(track, currentMin, currentMax, baseMin, baseMax);
        };

        const handleFilterItemPlaceholder = (min, max) => {
            if (!min.length && !max.length) {
                filterItemPlaceholder.textContent = filterItemPlaceholder.getAttribute("data-default-text");
            } else {
                let text = filterItemPlaceholder.getAttribute("data-from-to-text");
                text = text.replace("[from]", min.length ? min : baseMin);
                text = text.replace("[to]", max.length ? max : baseMax);
                filterItemPlaceholder.textContent = text;
            }
        };

        [minInput, maxInput].forEach((numberInput) => {
            numberInput.addEventListener("input", (e) => {
                e.target.value = e.target.value.replace(/\D/g, "");
                const enteredValue = parseInt(e.target.value, 10);
                const currentMin = Number(minInput.value) || baseMin;
                const currentMax = Number(maxInput.value) || baseMax;

                if (Number.isNaN(enteredValue)) {
                    syncTrackAndPlaceholders();
                    return;
                }

                if (e.target.classList.contains("-min")) {
                    const maxAllowed = Math.max(baseMin, currentMax - minGap);
                    const nextValue = Math.min(Math.max(enteredValue, baseMin), maxAllowed);
                    e.target.value = nextValue;
                } else if (e.target.classList.contains("-max")) {
                    const minAllowed = Math.min(baseMax, currentMin + minGap);
                    const nextValue = Math.max(Math.min(enteredValue, baseMax), minAllowed);
                    e.target.value = nextValue;
                }

                syncTrackAndPlaceholders();
                // handleFilterItemPlaceholder(minInput.value, maxInput.value);
            });
        });

        rangeInputs.forEach(rangeInput => {
            rangeInput.addEventListener("input", (e) => {
                if (e.target.classList.contains("-min")) {
                    if (parseInt(maxRange.value, 10) - parseInt(minRange.value, 10) <= minGap) {
                        minRange.value = parseInt(maxRange.value, 10) - minGap;
                    }
                    minInput.value = minRange.value;
                    if (placeholderFrom) placeholderFrom.textContent = minRange.value;
                } else {
                    if (parseInt(maxRange.value, 10) - parseInt(minRange.value, 10) <= minGap) {
                        maxRange.value = parseInt(minRange.value, 10) + minGap;
                    }
                    maxInput.value = maxRange.value;
                    if (placeholderTo) placeholderTo.textContent = maxRange.value;
                }
                handleTrackColor(track, minInput.value, maxInput.value, baseMin, baseMax);
                // handleFilterItemPlaceholder(minInput.value, maxInput.value);
            });
        });

        if (minInput?.value || maxInput?.value) {
            syncTrackAndPlaceholders();
            // handleFilterItemPlaceholder(minInput.value, maxInput.value);
        }
    };

    const handleTrackColor = (track, currentMinValue = 0, currentMaxValue = 0, baseMin = 0, baseMax = 0) => {
        const minValue = Number(currentMinValue) || baseMin;
        const maxValue = Number(currentMaxValue) || baseMax;
        let minPercent = 0;
        let maxPercent = 100;

        if (minValue <= baseMin) {
            minPercent = 0;
        } else {
            minPercent = ((minValue - baseMin) / (baseMax - baseMin)) * 100;
        }

        if (maxValue >= baseMax) {
            maxPercent = 100;
        } else {
            maxPercent = ((maxValue - baseMin) / (baseMax - baseMin)) * 100;
        }

        track.style.background = `linear-gradient(to right, #E7E8E9 ${minPercent}% , #101820 ${minPercent}% , #101820 ${maxPercent}%, #E7E8E9 ${maxPercent}%)`;
    };

    formRanges.forEach(element => {
        handleFormRange(element);
    });
};

window.initFormRange = formRange;

formRange();
